import type { ErrorInfo } from "@octopusdeploy/design-system-components";
import { ErrorPanel } from "@octopusdeploy/design-system-components";
import { OctopusError } from "@octopusdeploy/octopus-server-client";
import React from "react";
interface ErrorContentProps {
    error?: Error;
}
export function ErrorContent({ error }: ErrorContentProps) {
    if (!error) {
        return null;
    }
    const errorInfo: ErrorInfo = {
        message: "Unable to configure ephemeral environments",
        details: [],
    };
    if (OctopusError.isOctopusError(error)) {
        errorInfo.details = (error.Errors ?? []).map((e) => ({ text: e }));
    }
    else {
        errorInfo.details = [{ text: error.message }];
    }
    return <ErrorPanel error={errorInfo}/>;
}
